export { default } from './ShareMenu'
